module.exports = __webpack_public_path__ + "static/media/LO.073dfbfe.png";